
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import Rate from '@/components/elements/Rate.vue'
import LocalNav from '@/components/block/LocalNav.vue'
import MasterQuestion from '@/components/block/MasterQuestion.vue'
import MasterAnswer from '@/components/block/MasterAnswer.vue'
import MasterHeader from '@/components/block/MasterHeader.vue'
import MasterFooter from '@/components/block/MasterFooter.vue'
import { reactive, watch, defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import { useTest } from '@/provider/test'

export default defineComponent({
  name: 'Master',
  components: {
    HeadingLv3,
    Rate,
    LocalNav,
    MasterQuestion,
    MasterAnswer,
    MasterHeader,
    MasterFooter
  },
  setup() {
    const state = reactive<any>({
      selectedAnswer: null,
      localNav: [
        { id: 'question', label: '問題' },
        // { id: 'result', label: '成績' },
        { id: 'backnumber', label: 'バックナンバー' }
      ]
    })
    const { state: testState, getTest, getTests } = useTest()
    const route = useRoute()
    const getData = () => {
      const id = Number(route.params.id)
      state.localNav[0].label = id ? '問題' : '今日の問題'
      state.selectedAnswer = null
      if (id) getTest({ id })
      else getTests({ limit: 1 })
    }
    const receiveAnswer = (answer: any) => {
      state.selectedAnswer = answer
      location.href = '#answer'
    }

    watch(() => route.path, getData, { immediate: true })
    return {
      state,
      testState,
      receiveAnswer
    }
  }
})
